import React, { Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import StartFarm from '../pages/StartFarm';
import SignupSuccess from '../pages/SignupSuccess';
import Verification from '../pages/Verification';
import PasswordReset from '../pages/PasswordReset';
import Unauthorized from '../pages/Unauthorized';
import NotFound from '../pages/NotFound';
import Farms from '../pages/Farms';
import Orders from '../pages/Orders';
import Wallet from '../pages/Wallets';
import Profile from '../pages/Profile';
import Tutorial from '../pages/Tutorial';
import Farm from '../pages/Farm';
import Home from '../pages/Dashboard/Home';

import PrivateRoute from '../utils/PrivateRoute';
import ForgotPassword from '../pages/ForgotPassword';
import Login from '../pages/Login';
import Register from '../pages/Register';

import 'react-toastify/dist/ReactToastify.css';

const Router = () => (
  <Fragment>
    <ToastContainer autoClose={5000} />
    <Switch>
      <Redirect exact from="/" to="/login" />
      <Route path="/login" exact component={Login} />
      <Route path="/register" exact component={Register} />
      <Route path="/forgot-password" exact component={ForgotPassword} />
      <Route path="/signup-success" exact component={SignupSuccess} />
      <Route path="/verification" component={Verification} />
      <Route path="/password-reset" component={PasswordReset} />
      <Route path="/unauthorized" component={Unauthorized} />
      <PrivateRoute path="/home" exact component={Home} />
      <PrivateRoute path="/start-farm" component={StartFarm} />
      <PrivateRoute path="/farms" exact component={Farms} />
      <PrivateRoute path="/farms/:id" component={Farm} />
      <PrivateRoute path="/orders" exact component={Orders} />
      <PrivateRoute path="/tutorial" exact component={Tutorial} />
      <PrivateRoute path="/wallet" exact component={Wallet} />
      <PrivateRoute path="/profile" exact component={Profile} />
      <Route path="/notfound" component={NotFound} />
      <Redirect from="*" to="/notfound" />
    </Switch>
  </Fragment>
);

export default Router;
